import * as React from 'react';
import ReactTable from 'react-table';
import Swal from 'sweetalert2';

import EditUser from './EditUser';
import CreateUser from './CreateUser';
import Pagination from '../../common/pagination';
import NotifyHOC from '../../../HOC/Notifications';

import * as role from '../../../mapping/roles';
import * as userService from '../../../services/user.service';
import * as tokenService from '@nexxt/common/firebase/auth/userDetails';

import { User } from '../../../interface/user.interface';
import { getConfirmationBox } from '../../common/swal/Sweetalert';
import {
    titleHeader,
    alertMessage,
    parseAlertMessage
} from '../../../constants/alertMessage';
import Loader from '../../common/Loader/Loader';
import { PROJECT_MANAGER } from '@nexxt/common/constants';

interface UserProps {
    toastNotification: any;
}

interface UserState {
    users: User[];
    isRequesting: boolean;
    tenantId: number;
    isCreateUser: boolean;
    selectedOption: any;
    accessType: string;
    isEditUser: boolean;
    editableUser: any;
    filter: Filter;
}
interface Filter {
    Username: string;
}
class Users extends React.Component<UserProps, UserState> {
    private users: any = [];
    constructor(props) {
        super(props);
        this.state = {
            users: [],
            isRequesting: false,
            tenantId: null,
            isCreateUser: false,
            selectedOption: null,
            accessType: '',
            isEditUser: false,
            editableUser: '',
            filter: {
                Username: ''
            }
        };
    }

    componentDidMount() {
        const tenantId = tokenService.getTenantId();
        this.setState({ tenantId });
        this.getUsers();
    }

    handleChange = (selectedOption) => {
        this.setState({ selectedOption, accessType: selectedOption.value });
    };

    getUsers = async () => {
        this.setState({
            isRequesting: true
        });
        try {
            const users = await userService.fetchActiveUsers();
            this.setState({
                users,
                isRequesting: false
            });
            this.users = users;
        } catch (error) {
            this.setState({
                isRequesting: false
            });
            this.props.toastNotification.error(
                parseAlertMessage(
                    alertMessage.UNATHORIZED_ACCESS,
                    'Project manager'
                )
            );
        }
    };

    deleteUser = async (userId) => {
        getConfirmationBox({
            title: titleHeader.DELETE_ACCOUNT,
            message: alertMessage.DELETE_USER,
            showCloseButton: true,
            confirmButtonColor: '#349A71',
            showCancelButton: false
        }).then(async (result) => {
            if (result.value) {
                try {
                    this.setState({
                        isRequesting: true
                    });
                    await userService.deleteUser(userId);
                    this.setState({
                        isRequesting: false
                    });
                    this.props.toastNotification.success(
                        alertMessage.SUCCESS_USER_DELETE
                    );

                    this.getUsers();
                } catch (error) {
                    this.setState({
                        isRequesting: false
                    });
                    this.props.toastNotification.error(
                        error.response.data.message
                    );
                }
            } else if (result.dismiss === Swal.DismissReason.cancel) {
                this.setState({
                    isRequesting: false
                });
            }
        });
    };

    editUser = async (user) => {
        this.setState({
            isEditUser: true,
            editableUser: user
        });
    };

    buildColumns() {
        return [
            {
                Header: 'Email',
                accessor: 'email', // Note: Example of direct accessing data from accessor
                resizable: true,
                sortable: true
            },
            {
                Header: 'First Name',
                accessor: 'firstName',
                resizable: true,
                sortable: true,
                Cell: (props) => <span>{props.value}</span>
            },
            {
                Header: 'Last Name',
                accessor: 'lastName',
                resizable: true,
                sortable: true,
                Cell: (props) => <span>{props.value}</span>
            },
            {
                Header: 'Company',
                accessor: 'company',
                resizable: true,
                sortable: true,
                Cell: (props) => <span>{props.value}</span>
            },
            {
                Header: 'Job Title',
                accessor: 'jobTitle',
                resizable: true,
                sortable: true,
                Cell: (props) => <span>{props.value}</span>
            },
            {
                Header: 'Roles',
                accessor: 'accessType',
                resizable: true,
                sortable: true,
                className: 'align-right overflow-visible', // Note: Class name example
                Cell: (props) => <span>{role.mapping[props.value]}</span>
            }
            // {
            //     Header: 'Actions',
            //     accessor: 'id',
            //     className: 'align-center',
            //     headerClassName: 'align-center no-sort',
            //     Cell: (props) => (
            //         <React.Fragment>
            //             <ul className="table__actions">
            //                 <li
            //                     onClick={() => this.deleteUser(props.value)}
            //                     className="action__items"
            //                 >
            //                     <i className="nx nx-delete" />
            //                 </li>
            //                 {/*  @TODO: re-enable user editing
            //                 <li
            //                     onClick={() => this.editUser(props.original)}
            //                     className="action__items"
            //                 >
            //                     <i className="nx nx-edit" />
            //                 </li> */}
            //             </ul>
            //         </React.Fragment>
            //     )
            // }
        ];
    }

    // search = event => {
    //     const searchedItem = event.target.value;
    //     const filteredUser = this.users.filter(user => {
    //         return user.Username.includes(
    //             searchedItem || uppercaseFirstLetter(searchedItem)
    //         );
    //     });
    //     this.setState({
    //         users: filteredUser
    //     });
    // };

    // search = (name: keyof IFilter) => {
    onSearch = (event) => {
        const { name, value } = event.target;
        this.setState({
            filter: {
                ...this.state.filter,
                [name]: value
            }
        });
    };

    toggleCreateUser = () => {
        this.setState({ isCreateUser: !this.state.isCreateUser });
    };

    toggleEditUser = () => {
        this.setState({ isEditUser: !this.state.isEditUser });
    };

    render() {
        const {
            isRequesting,
            isCreateUser,
            tenantId,
            editableUser,
            isEditUser,
            filter,
            users
        } = this.state;

        return (
            <div className="tabs-content off-white">
                {isCreateUser && (
                    <CreateUser
                        tenantId={tenantId}
                        toggleCreateUser={this.toggleCreateUser}
                        getUsers={this.getUsers}
                    />
                )}

                {isEditUser && (
                    <EditUser
                        tenantId={tenantId}
                        user={editableUser}
                        toggleEditUser={this.toggleEditUser}
                        getUsers={this.getUsers}
                    />
                )}

                <div className="filters">
                    {/* @TODO: fix and re-enable user search (maybe?)
                    <div className="filters--search">
                        <input
                            type="text"
                            name="Username"
                            placeholder="Search users by username and email"
                            onChange={this.onSearch}
                        />
                        <i className="nx nx-search" />
                    </div>  */}
                    {tokenService.getAccessType() !== PROJECT_MANAGER && (
                        <div className="filters--add-user">
                            <button
                                className="btn btn--md btn--blue"
                                onClick={this.toggleCreateUser}
                            >
                                <i className="nx nx-add" /> Invite user
                            </button>
                        </div>
                    )}
                </div>
                {!isRequesting && users ? (
                    <ReactTable
                        data={users}
                        columns={this.buildColumns()}
                        defaultSorted={[
                            {
                                id: 'email',
                                desc: false
                            }
                        ]}
                        loading={!!isRequesting}
                        defaultPageSize={15}
                        pageSizeOptions={[5, 10, 15, 20]}
                        PaginationComponent={Pagination}
                        // LoadingComponent={({ loading }) =>
                        // loading ? <Loader /> : null
                        // }
                        NoDataComponent={(props) =>
                            !!isRequesting && !users ? (
                                <div className="rt-noData">No rows found</div>
                            ) : null
                        }
                    />
                ) : (
                    <Loader />
                )}
            </div>
        );
    }
}
export default NotifyHOC(Users);
